<template>
  <div id="layer-wrap" style="width: 900px;">
    <div ref="pdfCreateTgt">
      <div class="print_page">
        <div class="deal-con">
          <div class="entry-tit">
              <span>거래명세서</span>
          </div>
          <div class="deal-stat type1">
            <div>
              <table class="tb-row">
                <colgroup>
                  <col style="width: 35%;" />
                  <col style="width: auto;" />
                </colgroup>
                <thead>
                  <tr>
                    <th>고객성명</th>
                    <td><span>{{ fcltyInfo.fcltyNm }}</span></td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>거래연월</th>
                    <td class="_left"><span>{{ $cmmn.date.getAllKrFormat('ym', rqstDcsnDt) }}</span></td>
                  </tr>
                  <tr>
                    <th>전화번호</th>
                    <td class="_left"><span>{{ fcltyInfo.fcltyTlno }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table class="tb-row">
                <colgroup>
                  <col style="width: 16%;" />
                  <col style="width: auto;" />
                  <col style="width: 15%;" />
                  <col style="width: auto;" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>회사명</th>
                    <td><b>㈜온앤온정보시스템</b></td>
                    <th>대표</th>
                    <td>
                      <div class="tb-stamp">
                        김종찬,최병인
                        <span class="area">
                          <em class="sign"><img src="@/assets/img/common/stamp01.png" /></em><!-- 사인 영역 -->
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>주소</th>
                    <td colspan="3" class="_left"><span>서울특별시 강동구 길동 양재대로 1443 (길동, 동우빌딩) 701호</span></td>
                  </tr>
                  <tr>
                    <th>사업자 번호</th>
                    <td><span>120-81-84415</span></td>
                    <th>전화번호</th>
                    <td><span>1577-7522</span></td>
                  </tr>
                  <tr>
                    <th>업태</th>
                    <td><span>서비스</span></td>
                    <th>업종</th>
                    <td><span>소프트웨어 자문개발공급</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="deal-sum ft16px">
            <span>합계 금액 :</span>
            <b>{{ $cmmn.number.addComma(rqstAmt) }}</b>
            <span>원 (부가세 포함)</span>
          </div>
          <table class="tb-col">
            <colgroup>
              <col style="width: auto;" />
              <col style="width: 10%;" />
              <col style="width: 10%;" />
              <col style="width: 10%;" />
              <col style="width: 10%;" />
            </colgroup>
            <thead>
              <tr>
                <th>상품명</th>
                <th>수량</th>
                <th>단가</th>
                <th>금액</th>
                <th>비고</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-if="type == '1'" class="_left"><span>{{ $cmmn.date.getAllKrFormat('ym', stlmCycleVal) }} 세로이 서비스 이용료(노무,세무 신고)</span></td>
                <td v-if="type == '2'"><span>{{ stlmCycleVal }}년 연말정산 서비스 이용료</span></td>
                <td><span>1</span></td>
                <td><span>{{ $cmmn.number.addComma(rqstAmt) }}</span></td>
                <td><span>{{ $cmmn.number.addComma(rqstAmt) }}</span></td>
                <td></td>
              </tr>
              <tr v-for="n in 20" :key="n">
                <td>&nbsp;</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td class="ft16px pd15" colspan="5">
                  <span>합계 금액 : </span><b>{{ $cmmn.number.addComma(rqstAmt) }}</b> 원 (부가세 포함)
                </td>
              </tr>
            </tfoot>
          </table>
          <div class="box-type4">
            <ul class="txt-type2 depth1">
              <li><span>영업 및 고객 지원 : ㈜온앤온정보시스템 1577-7522</span></li>
            </ul>
          </div>
          <div class="__center">
            <img src="@/assets/img/common/logo.png" width="200" />
          </div>
        </div>
      </div>
    </div>
    <div style="overflow: hidden; height: 0">
      <div ref="pdfArea"></div>
    </div>
  </div>
  <html-to-pdf ref="htp"
               :flnm="'거래명세서'"
               @compt="comptCreatePdf"/>
</template>

<script setup>
import {defineProps, defineEmits, nextTick, reactive, ref, onMounted} from "vue";
import HtmlToPdf from "@/components/html-to-pdf.vue";
import {getStore, getUtils} from "@/utils/import";

const {$cmmn} = getUtils();
const {$loading} = getStore();

const props = defineProps({
  type: {
    type: String,
    required: true
  },
  rqstDcsnDt: {
    type: String,
    required: true
  },
  rqstAmt: {
    type: Number,
    required: true
  },
  fcltyInfo: {
    type: Object,
    required: true
  },
  stlmCycleVal: {
    type: String,
    required: true
  },
});
const emits = defineEmits(['close']);

const type = ref(props.type);  // 1: 세로이서비스, 2: 연말정산서비스
const rqstDcsnDt = ref(props.rqstDcsnDt); // 청구확정일시
const rqstAmt = ref(props.rqstAmt);       // 청구금액

const fcltyInfo = ref(props.fcltyInfo);

const pdfArea = ref(null);
const pdfCreateTgt = ref(null);
const pdf = reactive({
  isCnvring: false,
  isCreate: false,
  createTgt: '',
})

const btnPrint_click = async () => {
  await nextTick(() => {
    const area = pdfArea.value;

    while (area.hasChildNodes()) {
      area.removeChild(area.firstChild);
    }

    area.appendChild(pdfCreateTgt.value.cloneNode(true));

    Array.from(area.getElementsByClassName("del-elements")).forEach((info) => {
      info.style.visibility = "hidden";
    });

    pdf.ctrtcTgtElement = area;
  });

  createCtrtcPdf();
};

const finishInterval = ref(null);
const htp = ref(null);
const createCtrtcPdf = () => {
  $loading.on();

  finishInterval.value = setInterval(async () => {
    if (pdf.isCreate) {
      clearInterval(finishInterval.value);

      $loading.off();
      emits('close');
    } else {
      if (!pdf.isCnvring) {
        await nextTick(async () => {
          pdf.isCnvring = true;
          await htp.value.drawCanvasToPdf(
                  pdf.ctrtcTgtElement
          );
        })
      }
    }
  })
}

const comptCreatePdf = () => {
  pdf.isCreate = true;
  pdf.isCnvring = false;
}

onMounted(async () => {
  await btnPrint_click();
})
</script>

<style scoped>

</style>
